import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core';

import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';

import { EVENT_IMG } from '../constatns';

const styles = (theme) => ({
  box: {
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    width: '45%',
    padding: '40px 60px 30px',
    borderRadius: '5px',

    '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)': {
      padding: 0,
    },
    '&:first-child': {
      // backgroundColor: '#F9FBFC',
      backgroundColor: 'rgba(228,243,178,0.5)',
      '&:hover': {
        backgroundColor: '#e4f3b2',
        '& p': {
          // color: '#aacb3c',
          color: '#555555',
        },
      },
    },
    '&:last-child': {
      // backgroundColor: '#F9FBFC',
      backgroundColor: 'rgba(120,193,228,0.5)',
      '&:hover': {
        backgroundColor: '#78c1e4',
        '& p': {
          // color: '#164273',
          color: '#555555',
        },
      },
    },
    '& p': {
      textAlign: 'center',
      fontWeight: 'bold',
      fontSize: '1.6em',
      paddingTop: '20px',
    },
  },
});

class Choose extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      matches: window.matchMedia('(max-width:600px)').matches,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {}

  handleChange(type, e) {
    this.setState({ [type]: e.target.value });
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <CssBaseline />
        {/* <Topbar MIdx={6} SIdx={6} /> */}
        <Topbar MIdx={6} SIdx={5} />
        <Container>
          <Grid container justifyContent={'center'}>
            <Grid item xs={8}>
              <MainTitle>Sign-Up</MainTitle>
            </Grid>
            <Grid container justifyContent="center">
              <Grid container justifyContent={'space-between'} item xs={6} sm={6} md={5} lg={4}>
                <Grid
                  item
                  onClick={() => this.props.history.push({ pathname: '/signup', search: '?lang=kor' })}
                  style={{ cursor: 'pointer' }}
                  className={classes.box}
                >
                  <img src={`${EVENT_IMG}/for_korean_hover.png`} alt="for korean" style={{ width: '100%' }} />
                  <p>For Korean</p>
                </Grid>
                <Grid
                  item
                  onClick={() => this.props.history.push({ pathname: '/signup', search: '?lang=eng' })}
                  style={{ cursor: 'pointer' }}
                  className={classes.box}
                >
                  <img src={`${EVENT_IMG}/for_international_hover.png`} alt="for international" style={{ width: '100%' }} />
                  <p>For International</p>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Choose);
